import React, { useState } from 'react';
// GraphQL
import {
  RetrieveProjectDataFromGraphQL,
  HasuraClientLoginDataCall,
  matchUserLoginInfoToProject
} from './healthMetricsQueries';
// Styles
import { UseStyles } from './healthMetricStyles';
//Components
import { LoadingScreen } from './loadingScreen';
import { ProjectHealthDatagrid } from './CSVData';
// Helpers
import {
  cleanProjectDataForFrontEnd
} from './helperFunctions';

export const HealthMetricsList = props => {
  const classes = UseStyles();
  const [userLoginDataLoaded, setUserLoginDataLoaded] = useState(false);

  // Initial call to GraphQL to retrieve Project data
  let projectData = RetrieveProjectDataFromGraphQL(props);

  if (projectData) {
    projectData = cleanProjectDataForFrontEnd(projectData);
  }

  if (!projectData) return (
    <LoadingScreen loadingStyles={classes.skeletonLoading} />
  );

  return (
    <>
      <ProjectHealthDatagrid
        projectInfo={projectData.allProjects}
        companyInfo={projectData.allCompanies}
      />
    </>
  );
};
